import { render, staticRenderFns } from "./web-form.vue?vue&type=template&id=7d9defa1&"
import script from "./web-form.js?vue&type=script&lang=js&"
export * from "./web-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports